module.exports = __webpack_public_path__ + "static/media/box_512.d7f3104e.png";